import projectAgentRelationsSettingsComponent from './project-agent-relations-settings.component';

const projectAgentRelationsSettingsModule = angular.module('projectAgentRelationsSettings', [])
  .component('projectAgentRelationsSettings', projectAgentRelationsSettingsComponent)
  .name;

export default projectAgentRelationsSettingsModule;
